module.exports = __webpack_public_path__ + "img/v2k_bildwortmarke.e21e93b7.png";